"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return dataURItoBlob;
    }
});
function dataURItoBlob(dataURI) {
    const byteCharacters = atob(dataURI.split(",")[1]);
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const byteArray = new Uint8Array(byteCharacters.length);
    for(let i = 0; i < byteCharacters.length; i++){
        byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([
        byteArray
    ], {
        type: mimeString
    });
}
